module.exports = "<p>{{title}}</p>\n<p>{{createBy}}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/surveys/cut/cut-item/cut-item.component.html
// module id = ./src/app/routes/surveys/cut/cut-item/cut-item.component.html
// module chunks = main